export default "__VITE_ASSET__D_8LGRHs__"